<template>
  <div class="swiper">
    <div class="swiper-wrapper">
      <slot />
    </div>
    <slot name="pagination" />
    <slot name="button-prev" />
    <slot name="button-next" />
  </div>
</template>

<script>
import Swiper, { Autoplay, Navigation, Pagination, EffectCoverflow, Lazy, FreeMode } from 'swiper'

export default {
  name: 'Swiper',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      swiper: null
    }
  },
  mounted() {
    if (!this.swiper) {
      this.swiper = new Swiper(this.$el, {
        modules: [Autoplay, Navigation, Pagination, EffectCoverflow, Lazy, FreeMode],
        ...this.options
      })
      const vm = this
      this.swiper.on('slideChange', function () {
        vm.activeIndex = this.activeIndex
        vm.$emit('change', this.activeIndex)
        vm.$emit('slide-change', this.activeIndex)
      })
    }
  },
  // updated () {
  //   if (this.swiper) {
  //     this.$nextTick(() => {
  //       this.swiper.loopDestroy()
  //       this.swiper.loopCreate()
  //     })
  //   }
  // },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy()
      delete this.swiper
    }
  }
}
</script>
